export const dechex = (input: number | string | undefined): string => {
    let value = Number(input ?? 0)
    if (value < 0) {
        value = 0xFFFFFFFF + value + 1
    }
    return parseInt(String(value), 10).toString(16)
}

export const dechexTime = (input: number | string | undefined): string => {
    const dechexed = dechex(input)

    return dechexed
        .split('')
        .reverse()
        .join('')
        .match(/.{1,2}/g)
        ?.reverse()
        .join(':') ?? ''
}
